export default "__VITE_ASSET__DS_Scc8L__"